// extracted by mini-css-extract-plugin
module.exports = {"ButtonArea":"ConstructionFooter_ButtonArea__2JC69"};